'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './register-success.routes';

export class RegisterSuccessComponent {
  /*@ngInject*/
  constructor() {
    this.message = 'Hello';
  }
}

export default angular.module('appApp.register-success', [uiRouter])
  .config(routes)
  .component('registerSuccess', {
    template: require('./register-success.html'),
    controller: RegisterSuccessComponent,
    controllerAs: 'registerSuccessCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/register-success/register-success.component.js